import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Text,
  TouchableOpacity,
  View,
  Image,
} from "react-native";
import RNPickerSelect from "react-native-picker-select";
import InputDefault from "../../components/Form/InputDefault";
import api from "../../services/api";
import { toast } from "./../../utils/toast";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "./styles";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";

const NewBankAccount = ({ navigation }) => {
  const [bank, setBank] = useState(0);
  const [typeAccount, setTypeAccount] = useState(0);
  const [agency, setAgency] = useState("");
  const [account, setAccount] = useState("");
  const [itemsBanks, setItemsBanks] = useState([]);
  const [accountType, setAccountType] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getBanks();
    getAccountType();
  }, []);

  const intl = useIntl();

  function getBanks() {
    setIsLoading(true);
    api
      .get("/banks")
      .then((res) => {
        var banks = [];
        res.data.data.map((item) => {
          banks.push({
            label: item.bank,
            value: item.id,
          });
        });

        setItemsBanks(banks);
        setIsLoading(false);
      })
      .catch((error) => {
        toast(
          intl.formatMessage({ id: "newBankAccount.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  function getAccountType() {
    setIsLoading(true);
    api
      .get("/bank-account-types")
      .then((res) => {
        var types = [];

        res.data.data.map((item) => {
          types.push({
            label: intl.formatMessage({ id: item.name }),
            value: item.id,
          });
        });

        setAccountType(types);
        setIsLoading(false);
      })
      .catch((error) => {
        toast(
          intl.formatMessage({ id: "newBankAccount.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  async function saveBank() {
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    if (!bank) {
      toast(
        intl.formatMessage({ id: "newBankAccount.selecioneBanco" }),
        "#DA1414",
        3000
      );
      return false;
    }

    if (!typeAccount) {
      toast(
        intl.formatMessage({ id: "newBankAccount.selecioneTipoConta" }),
        "#DA1414",
        3000
      );
      return false;
    }

    if (!agency) {
      toast(
        intl.formatMessage({ id: "newBankAccount.preenchaNumAgencia" }),
        "#DA1414",
        3000
      );
      return false;
    }

    if (!account) {
      toast(
        intl.formatMessage({ id: "newBankAccount.preenchaNumConta" }),
        "#DA1414",
        3000
      );
      return false;
    }

    setIsLoading(true);
    const data = {
      bank_id: bank,
      bank_account_type_id: typeAccount,
      branch: agency,
      account: account,
    };

    api
      .post("/bank-accounts", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        navigation.goBack();
        setIsLoading(false);
      })
      .catch(() => {
        toast(
          intl.formatMessage({ id: "newBankAccount.erroCadastrarBanco" }),
          "#DA1414",
          3000
        );
        setIsLoading(false);
      });
  }
  const handleSelect = (value) => {
    setBank(value);
  };
  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="bankAccount.contaBancaria" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="bankAccount.adicioneNovaConta" />
          </Text>
        }
      />

      <View style={styles.container}>
        <View style={{ marginTop: 15, marginBottom: 15, alignItems: "center" }}>
          <View style={{}}>
            <Text style={styles.cardTitle}>
              <FormattedMessage id="newBankAccount.novaConta" />
            </Text>
            <Text style={styles.label}>
              <FormattedMessage id="newBankAccount.selecioneTipoContaForm" />
            </Text>

            {accountType.map((el, index) => (
              <TouchableOpacity
                key={index}
                style={{
                  marginTop: 5,
                  borderWidth: 0.5,
                  borderColor: "#000",
                  borderRadius: 4,
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                  width: 320,
                  backgroundColor:
                    el.value === typeAccount ? "#f1f1f1" : "#fff",
                }}
                onPress={() => {
                  setTypeAccount(el.value);
                }}
              >
                <Text
                  style={{ color: el.value === typeAccount ? "#333" : "#222" }}
                >
                  {el.label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
        <View
          style={{ marginTop: 20, alignItems: "center", alignSelf: "center" }}
        >
          <View style={{ alignSelf: "flex-start" }}>
            <Text style={styles.label}>
              <FormattedMessage id="newBankAccount.selecioneBancoForm" />
            </Text>
          </View>

          <View style={{ alignItems: "center", alignSelf: "center" }}>
            <FormattedMessage id="newBankAccount.placeholderSelecioneBanco">
              {(placeholder) => (
                <RNPickerSelect
                  key={"rnpickselect1"}
                  onValueChange={(value) => handleSelect(value)}
                  placeholder={{
                    label: placeholder,
                    value: null,
                  }}
                  items={itemsBanks}
                  //value={bank}
                  style={{
                    inputWeb: {
                      borderRadius: 4,
                      paddingHorizontal: 10,
                      width: 320,
                      height: 40,
                      marginVertical: 10,
                      color: "#222",
                    },
                  }}
                />
              )}
            </FormattedMessage>
          </View>
        </View>

        <View
          style={{ alignItems: "center", alignSelf: "center", minWidth: 320 }}
        >
          <FormattedMessage id="newBankAccount.placeholderAgencia">
            {(placeholder) => (
              <InputDefault
                value={agency}
                onValueChange={(value) => setAgency(value)}
                placeholder={placeholder}
                type={"numeric"}
              />
            )}
          </FormattedMessage>

          <FormattedMessage id="newBankAccount.placeholderConta">
            {(placeholder) => (
              <InputDefault
                value={account}
                onValueChange={(value) => setAccount(value)}
                placeholder={placeholder}
                type={"numeric"}
                style={styles.inputBank}
              />
            )}
          </FormattedMessage>
        </View>

        <View style={styles.warningContainer}>
          <Image
            source={require("../../../assets/information-icon.svg")}
            style={styles.img}
          />
          <Text style={styles.titularityText}>
            <FormattedMessage id="newBankAccount.erroContaTitulalidade" />
          </Text>
        </View>

        <View style={styles.contentBtn}>
          <TouchableOpacity
            onPress={saveBank}
            disabled={isLoading ? true : false}
            style={styles.btn}
          >
            {isLoading ? (
              <ActivityIndicator color="#2797A2" size="small" />
            ) : (
              <Text style={styles.textBtn}>
                <FormattedMessage id="newBankAccount.btnAdicionar" />
              </Text>
            )}
          </TouchableOpacity>
          <GoBackButton style={{ marginTop: 12 }} />
        </View>
      </View>
    </>
  );
};

export default NewBankAccount;
